<template>
  <div class="perfect">
    <div class="top flex aCenter jBetween">
      <img src="~assets/img/tlogo.png" alt="" />
      <div class="flex aCenter">
        <!-- <div class="QQ">{{ $store.state.userinfo.email }}</div> -->
        <div class="QQ">{{ $store.state.userinfo.group_name }}</div>
        <div class="outlogin" @click="outlogin">退出登录</div>
      </div>
    </div>
    <!-- 注册完之后默认弹出的完善信息 -->
    <!-- 遮罩层 -->
    <div class="zhezhao" v-show="showzhezhao"></div>
    <div class="box column" v-show="showzhezhao">
      <div class="cont-top">
        <div>完善您的企业信息</div>
        <div @click="showzhezhao = false" style="cursor: pointer">
          稍后完善<i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="content">
        <div class="flex aCenter jAround">
          <div class="left">
            <img src="../../assets/img/icon_hangye.png" alt="" />
            <span class="text">你的行业</span>
          </div>
          <div class="flex flex-1">
            <el-radio-group v-model="radio" @change="radiochange">
              <el-radio class="radio" label="电商" border>
                <div class="column aCenter jBetween">
                  <img
                    v-if="activeradio1"
                    src="../../assets/img/icon_dianshang_selected.png"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../assets/img/icon_dianshang_normal.png"
                    alt=""
                  />
                  <div class="bot-text">电商</div>
                </div>
              </el-radio>
              <el-radio class="radio" label="APP" border>
                <div class="column aCenter jBetween">
                  <img
                    v-if="activeradio2"
                    src="../../assets/img/icon_app_selected.png"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../assets/img/icon_app_normal.png"
                    alt=""
                  />
                  <div class="bot-text">APP</div>
                </div>
              </el-radio>
              <el-radio class="radio" label="游戏" border>
                <div class="column aCenter jBetween">
                  <img
                    v-if="activeradio3"
                    src="../../assets/img/icon_youxi_selected.png"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../assets/img/icon_youxi_normal.png"
                    alt=""
                  />
                  <div class="bot-text">游戏</div>
                </div>
              </el-radio>
              <el-radio class="radio" label="品牌其他" border>
                <div class="column aCenter jBetween">
                  <img
                    v-if="activeradio4"
                    src="../../assets/img/icon_qita_selected.png"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../assets/img/icon_qita_normal.png"
                    alt=""
                  />
                  <div class="bot-text">品牌其他</div>
                </div>
              </el-radio>
            </el-radio-group>
          </div>
        </div>

        <div class="flex aCenter jAround mar-top">
          <div class="left">
            <img src="../../assets/img/icon_yezz.png" alt="" />
            <span class="text">你的营业执照</span>
          </div>
          <div class="flex-1">
            <el-upload
              class="upload-demo"
              drag
              :on-success="handleAvatarSuccess"
              :show-file-list="false"
              action="/api/login/uploadImg"
              multiple
            >
              <div v-if="img == ''">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  点击上传正确的营业执照， 否则审核可能不会通过
                </div>
              </div>
              <div v-else>
                <img class="iimg" :src="img" alt="" />
              </div>
            </el-upload>
          </div>
        </div>

        <div class="sbsb flex aCenter jCenter">
          <!-- <img src="../../assets/img/icon_true.png" alt="" />
          <div>识别失败，请填写如下信息</div> -->
        </div>

        <div class="flex aCenter jAround mar-top">
          <div class="left">
            <img src="../../assets/img/icon_qyxx.png" alt="" />
            <span class="text">你的企业信息</span>
          </div>
          <div class="flex-1" style="display: none">
            <div class="linethree">
              营业执照成功上传后，将在此处显示相应的企业信息，如有不符，可手动调整
            </div>
          </div>

          <div class="flex-1">
            <div class="flex aCenter matop">
              <div class="inputext">公司名称</div>
              <el-input placeholder="请输入中文公司名称" v-model="group_name">
              </el-input>
            </div>
            <div class="flex aCenter matop">
              <div class="inputext">公司英文名称</div>
              <el-input placeholder="请输入英文公司名称" v-model="en_name">
              </el-input>
            </div>
            <div class="flex aCenter matop">
              <div class="inputext">统一社会 信用代码</div>
              <el-input
                placeholder="请输入统一社会信用代码"
                @blur="inputChange"
                v-model="group_code"
              >
              </el-input>
            </div>
            <div class="flex aCenter matop">
              <div class="inputext">公司注册地址</div>
              <el-input placeholder="请输入中文公司注册地址" v-model="address">
              </el-input>
            </div>
            <div class="flex aCenter matop">
              <div class="inputext">公司英文注册地址</div>
              <el-input
                placeholder="请输入英文公司注册地址"
                v-model="en_address"
              >
              </el-input>
            </div>
            <div class="flex aCenter matop">
              <div class="inputext">法人代表</div>
              <el-input placeholder="请输入法人代表" v-model="username">
              </el-input>
            </div>
            <div class="btn" @click="final">完成</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 左侧内容 -->
    <div class="home-box flex">
      <el-menu
        style="width: 260px"
        router
        :default-active="active"
        class="el-menu-vertical-demo"
        @open="handleOpen"
      >
        <el-menu-item index="Home">
          <i class="el-icon-house"></i>
          <span slot="title">首页</span>
        </el-menu-item>

        <el-submenu index="Record">
          <template slot="title">
            <i class="el-icon-document-copy"></i>
            <span>交易记录</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="Payrecord">充值记录</el-menu-item>
            <el-menu-item index="Buyrecord">购买记录</el-menu-item>
          </el-menu-item-group>
        </el-submenu>

        <el-submenu index="Profile">
          <template slot="title">
            <i class="el-icon-user"></i>
            <span>我的信息</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="Profile">个人设置</el-menu-item>
            <el-menu-item index="Store">企业信息</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
      <!-- 右侧内容 -->

      <div class="right-content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import Index from "./Index";
import { getQyApi } from "../../network/api";
export default {
  name: "Perfect",
  mixins: [Index],
  created() {
    console.log(this.$store.state.userinfo);

    this.active = this.$route.name;
    let token = this.$store.state.userinfo.token;
    let is_ok = this.$store.state.userinfo.is_ok;
    if (is_ok == 1) {
      this.showzhezhao = false;
    }
    if (is_ok == 0) {
      this.showzhezhao = true;
    }
    getQyApi(token)
      .then((res) => {
        // console.log(res);
        this.type = res.data.data.type || "";
        this.radio = res.data.data.type || "";
        this.img = res.data.data.img || "";
        this.group_name = res.data.data.group_name || "";
        this.en_name = res.data.data.en_name || "";
        this.group_code = res.data.data.group_code || "";
        this.address = res.data.data.address || "";
        this.en_address = res.data.data.en_address || "";
        this.username = res.data.data.username || "";
        if (this.radio == "电商") {
          this.activeradio1 = true;
        } else if (this.radio == "APP") {
          this.activeradio2 = true;
        } else if (this.radio == "游戏") {
          this.activeradio3 = true;
        } else if (this.radio == "品牌其他") {
          this.activeradio4 = true;
        }
      })
      .catch();
  },

  // watch: {
  //   $route(to, from) {
  //     console.log(to);
  //     if (to.name == "Buyrecord") {
  //       this.active = "buyrecord";
  //     } else if (to.name == "Home") {
  //       this.active = "home";
  //     } else if (to.name == "Store") {
  //       this.active = "store";
  //     } else if (to.name == "Profile") {
  //       this.active = "profile";
  //     } else if (to.name == "Payrecord") {
  //       this.active = "payrecord";
  //     }
  //   },
  // },
};
</script>
<style scoped src="./Perfect.css"></style>
